import { createStore } from 'vuex'
import sidebarStore from './modules/sidebar'
import auth from './modules/auth'
import error from './error'
import units from './modules/units'
import projects from './modules/projects'
import developers from './modules/developers'
import users from './modules/users'
import requests from './modules/requests'
import leads from './modules/leads'
import teams from './modules/team'
import comments from './modules/comments'
import notifications from './modules/notifications'
import offers from './modules/offers'

export default createStore({
  
  modules: {
    sidebar: sidebarStore,
    auth: auth,
    error:error,
    units:units,
    projects:projects,
    developers:developers,
    users:users,
    requests:requests,
    leads:leads,
    teams:teams,
    comments:comments,
    notifications:notifications,
    offers:offers
  }
})
